import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sisMapActions from "store/modules/rds_sisMap";
import $ from "jquery";
import Select from "react-select";
import { LoadingContext } from "../../loadingContext";

import { IoIosArrowForward } from "react-icons/io";
import { MdClose, MdVideoCall } from "react-icons/md";
import { BsPlus, BsDash } from "react-icons/bs";
import { AiOutlineUnorderedList } from "react-icons/ai";

import "./transportation.scss";

import SisSelect from "store/sis/component/SisSelect";
import SisOverlay from "store/sis/SisOverlay";
import SisCheckbox from "store/sis/component/SisCheckbox";

import ReactHlsPlayer from "react-hls-player";

class Transportation extends Component {
	static contextType = LoadingContext;
	state = {
		title: "교통",
		activeItem: "",
		lstDay: [], // 날짜(일) 리스트
		lstSgg: [], // 시군 리스트
		lstEmd: [], // 읍면동 리스트
		shipStartList: [], // 해운 출발 항구 리스트
		shipStartSggList: [], // 해운 출발 시군 리스트
		trainStartCondition: false, // KTX/열차 출발지 시군구 리스트 없을 때
		trainStartSggList: [], // KTX/열차 출발지 - 시군구
		ktxStartCode: "",
		ktxStartName: "",
		ktxEndCode: "",
		ktxEndName: "",
		busStartCode: "",
		busStartName: "",
		busEndCode: "",
		busEndName: "",
		isLoadUtisLayer: false,
		lstYmd: [],
		lstGb: [],
		source: "",
	};

	openSearchWrap = (evt) => {
		$("#transportationWrap .itemsWrap").hide();
		$("#transportationWrap .searchWrap").show();
		$("#transportationWrap .close").show();
		$(".source").show();
		$("#transportationWrap .searchWrap").css("top","60px");		

		const id = $(evt.target).closest(".item").attr("id");
		const title = $(evt.target).closest(".item").find("span").text();
		let source = "";

		if(id=="trafficAreas"){
			this.getYmd("traffic_areas");		
			this.getGb(id);
			source = "교통정책연구실";
		}else if(id=="platform"){
			this.getYmd("bit_info");
			source = "대중교통과";		
			//this.getGb(id);
		}else if(id=="parking"){
			this.getYmd("car_park_info_gj");		
			source = "공공데이터포털";
			//this.getGb(id);
		}

		this.setState({
			
			activeItem: id,
			title,
			source,
		});

		
	};

	closeSearchWrap = () => {
		$("#transportationWrap .searchWrap").hide();
		$("#transportationWrap .itemsWrap").show();
		$("#apartModal .close").click();
		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$("#transportationWrap .close").hide();
		$(".source").hide();
		$("#transportationWrap .searchWrap").css("top","");

		this.setState({
			activeItem: "",
			title: "교통",
		});
	};

	// 읍면동 불러오기
	getEmd = (value) => {
		let lstEmd = [];

		$.ajax({
			url: "/map/getEmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				lstEmd = res;

				this.setState({
					lstEmd: [{ emdCd: "0", emdNm: "=== 전체 ===" }, ...lstEmd],
				});
			},
		});
	};

	//년도 가져오기
	getYmd = (value) => {
		let lstYmd = [];

		$.ajax({
			url: "/map/getYmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				
				lstYmd = res;

				this.setState({
					lstYmd: [...lstYmd],
				});
			},
		});
	};

	//그룹 가져오기
	getGb = (id) => {
		let lstGb = [];

		if(id==="trafficAreas"){
			lstGb = [
				{group:'AMTIME',name:'오전 첨두'}, 
				{group:'PMTIME', name:'오후 첨두'},
				{group:'DAYTIME', name:'주간'},
				{group:'24HTIME', name:'24시간'}
			];
		}
		this.setState({
			lstGb: [{ group: "0", name: "=== 전체 ===" }, ...lstGb],
		});		
	};

	// 오버레이 클릭 이벤트
	_overlayClickEvent = (ele, id, activeItem, noProps = false,mapZoom = false) => {
		const { actions, layout, sis } = this.props;
		let overlayElement;
		let col;

		if (activeItem === "cctv" || activeItem === "traffic") {
			$(".cctvJibunValue").text(ele.cctvNm);
			ReactDOM.render(<ReactHlsPlayer url={ele.cctvUrl} autoplay={true} controls={true} width={"100%"} height={"auto"} />, $("#cctvVideo")[0]);
			$("#cctvModal").show();
		} else if (activeItem === "parking") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="transportationTitle">{ele.parkName}</span>
					<span className={ele.parkGb === "공영" ? "tag parking" : "tag parking2"}>{ele.parkGb}</span>
					<span className="transportationAddress">
						{ele.jibunAddr}
					</span>
					<table>
						<caption>주차장</caption>
						<tbody>
							<tr>
								<th>주차장 요금</th>
								<td>{ele.parkCharg ? ele.parkCharg  : "-"}</td>
							</tr>
							<tr>
								<th>주차장 종류</th>
								<td>{ele.parkType ? ele.parkType : "-"}</td>
							</tr>
							<tr>
								<th>주차장 면수</th>
								<td>{ele.meynCnt != null && !isNaN(Number(ele.meynCnt)) ? Number(ele.meynCnt).toLocaleString() : "-"}</td>
							</tr>
							<tr>
								<th>급지</th>
								<td>{ele.geubType ? ele.geubType : "-"}</td>
							</tr>
						</tbody>
					</table>
					{/*
					<span>주차장 요금 : {ele.parkCharg != null && !isNaN(Number(ele.parkCharg)) ? Number(ele.parkCharg).toLocaleString() : "-"}</span>
					<span>주차장 종류 : {ele.parkType ? ele.parkType : "-"}</span>
					<span>주차장 면수 : {ele.meynCnt != null && !isNaN(Number(ele.meynCnt)) ? Number(ele.meynCnt).toLocaleString() : "-"}</span>
					<span>급지 : {ele.geubType ? ele.geubType : "-"}</span>
					*/}
				</>
			);
		}
		//platform
		else if (activeItem === "platform") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="transportationTitle">{ele.busstopName}</span>
					<table>
						<caption>승차인원현황</caption>
						<tbody>
							<tr>
								<th>단일 일반</th>
								<td>{ele.singleGen != null && !isNaN(Number(ele.singleGen)) ? Number(ele.singleGen).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>단일 청소년</th>
								<td>{ele.singleTeen != null && !isNaN(Number(ele.singleTeen)) ? Number(ele.singleTeen).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>단일 어린이</th>
								<td>{ele.singleKid != null && !isNaN(Number(ele.singleKid)) ? Number(ele.singleKid).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>단일 전체</th>
								<td>{ele.singleCnt != null && !isNaN(Number(ele.singleCnt)) ? Number(ele.singleCnt).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>환승 일반</th>
								<td>{ele.transferGen != null && !isNaN(Number(ele.transferGen)) ? Number(ele.transferGen).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>환승 청소년</th>
								<td>{ele.transferTeen != null && !isNaN(Number(ele.transferTeen)) ? Number(ele.transferTeen).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>환승 어린이</th>
								<td>{ele.transferKid != null && !isNaN(Number(ele.transferKid)) ? Number(ele.transferKid).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>환승 전체</th>
								<td>{ele.transferCnt != null && !isNaN(Number(ele.transferCnt)) ? Number(ele.transferCnt).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>총이용자수</th>
								<td>{ele.totalCnt != null && !isNaN(Number(ele.totalCnt)) ? Number(ele.totalCnt).toLocaleString() : "-"}명</td>
							</tr>

						</tbody>
					</table>
				</>
			);

		}else if (activeItem === "trafficAreas") {
			// trafficTotal과 timeTraffic을 쉼표로 나누어 배열로 변환
			const trafficTotalValues = ele.trafficTotal ? ele.trafficTotal.toLocaleString().split(',') : [];
			const timeTrafficValues = ele.timeTraffic ? ele.timeTraffic.split(',') : [];

			// 원하는 순서 정의
			const order = ['오전 첨두', '오후 첨두', '주간', '24시간'];

			// timeTrafficValues를 기준으로 정렬할 새로운 배열 생성
			const sorted = timeTrafficValues.map((value, index) => ({
				time: value.trim(),  // 문자열 앞뒤 공백 제거
				traffic: trafficTotalValues[index] // 같은 인덱스의 trafficTotalValues 유지
			})).sort((a, b) => order.indexOf(a.time) - order.indexOf(b.time)); // 정의한 순서대로 정렬

			// 정렬된 값으로 다시 배열 생성
			const sortedTimeTrafficValues = sorted.map(item => item.time);
			const sortedTrafficTotalValues = sorted.map(item => item.traffic);
		
			// 반복문을 사용하여 값 출력
			let rows = [];
			for (let i = 0; i < trafficTotalValues.length; i++) {
				rows.push(
					<React.Fragment key={i}>
						<tr>
							<th>측정시간</th>
							<td>{sortedTimeTrafficValues[i]}</td> {/* timeTraffic 값 출력 */}
						</tr>
						<tr>
							<th>차량수</th>
							<td>{sortedTrafficTotalValues[i] != null && !isNaN(Number(sortedTrafficTotalValues[i])) ? Number(sortedTrafficTotalValues[i]).toLocaleString() : "-"}</td> {/* trafficTotal 값 출력 */}
						</tr>
					</React.Fragment>
				);
			}
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="transportationTitle">{ele.areaName}</span>
					<table>
						<caption>교통량</caption>
						<tbody>			
							{rows.length > 0 ? rows : (
								<tr>
									<td colSpan="2">데이터가 없습니다</td>
								</tr>
							)}
						</tbody>
					</table>
				</>
			);
		}
		let overlay = sis.sisMap.map.getOverlayById("overlaySelector");
		sis.sisMap.map.removeOverlay(overlay);

		actions.addResultOverlay({
			element: overlayElement,
			data: ele,
			id,
			className: "removeOverlayWrap",
			isTop: true,
			noProps,
			mapZoom,
		});
	};

	// 오버레이 클릭 이벤트(겹치는거 확인)
	overlayClickEvent = (ele, evt, overlay) => {
		let ss = $(evt);
		const { actions, layout, sis } = this.props;

		let col = "";
		const activeItem = $(evt.target).closest(".sisOverlayWrap").find("span:first").attr("class");
		const tag = $(evt.target).closest(".sisOverlayWrap").find("span:first").attr("tag");
		const id = `transportation_${activeItem}_removeOverlay`;
		$(`#${id}`).remove();

		let existOverlay = sis.sisMap.map.getOverlayById(id);
		if (existOverlay) sis.sisMap.map.removeOverlay(existOverlay);

		if (activeItem === "trafficAreas") col = "areaName";
		else if (activeItem === "platform") col = "busstopName";
		else if (activeItem === "parking") col = "parkName";
		
		const arrOverlays = [];
		const pos = overlay.getPosition();
		const interval = 1;
		let xInterval = 0;
		let yInterval = 0;
		const overlays = sis.sisMap.map.getOverlays().getArray();

		$.each(overlays, (idx, item) => {
			let targetPos = item.getPosition();

			if (targetPos) {
				targetPos = targetPos;

				xInterval = Math.abs(pos[0] - targetPos[0]);
				yInterval = Math.abs(pos[1] - targetPos[1]);

				if (xInterval <= interval && yInterval <= interval) {
					arrOverlays.push(item);
				}
			}
		});

		if (arrOverlays.length > 1) {
			// if (true) {
			// 오버레이 생성
			const overlayElement = document.createElement("div");
			document.body.appendChild(overlayElement);
			overlayElement.className = "overlaySelector";
			overlayElement.id = "overlaySelector";

			let overlay = sis.sisMap.map.getOverlayById("overlaySelector");

			if (overlay) sis.sisMap.map.removeOverlay(overlay);
			overlay = new SisOverlay(`#overlaySelector`, sis.sisMap.map, "bottom-center", [0, 0]);
			overlay.setPosition(pos);
			$(overlayElement).parent().css("z-index", 9999);

			arrOverlays.forEach((item) => {
				const props = item.getProperties();

				if (props[col]) {
					const element = document.createElement("div");
					element.innerText = props[col];
					$(overlayElement).append(element);

					$(element).on("click", () => {
					this._overlayClickEvent(props, id, activeItem, true);
					sis.sisMap.map.removeOverlay(overlay);
					});
				}

				// $(overlayElement).append(`<div>${props.buildNm}</div>`);
			});

		 } else {
			this._overlayClickEvent(ele, id, activeItem);
		 }

		return;
	};

	

	// 오버레이 생성
	createOverlay = (data, id) => {
		const { actions } = this.props;
		const { activeItem } = this.state;
	
		// 검색 결과 UI 업데이트
		const searchableItems = ["parking", "trafficAreas", "platform"];
		if (searchableItems.includes(activeItem)) {
		const resultText = `<div class='listWrap' tag='false'>
								<span class='cnt'>검색결과 <a>${data.length.toLocaleString()}</a>건</span>
							</div>`;
		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$(".tabWrap .tab.active .searchWrap").append(resultText);
		}
	
		// 오버레이 생성 및 이벤트 바인딩
		data.forEach((ele) => {
		let overlayElement, isCCTV = false, offsetValue = [5, -10];
	
		const overlayConfig = {
			cctv: { element: <span className={activeItem}>{ele.cctvFormat}</span>, isCCTV: true, offset: [5, 10] },
			traffic: { element: <span className={activeItem}>{ele.cctvFormat}</span>, isCCTV: true, offset: [5, 10] },
			parking: {
				element: (
					<span className={activeItem}>
					<span className={ele.parkGb === "공영" ? "tag parking" : "tag parking2"} style={{ marginRight: "3px" }}>
						{ele.parkGb}
					</span>
					{ele.parkName}
					</span>
				),
			},
			platform: { element: <span className={activeItem}>{ele.busstopName}</span> },
			trafficAreas: { element: <span className={activeItem}>{ele.areaName}</span> },
		};
	
		if (overlayConfig[activeItem]) {
			({ element: overlayElement, isCCTV = false, offset: offsetValue = [5, -10] } = overlayConfig[activeItem]);
		}
	
		actions.addResultOverlay({
			element: overlayElement,
			data: ele,
			id: `${id}_${ele.gid}`,
			isCCTV,
			offsetValue,
			className: "transportationOverlayWrap",
			onClick: this.overlayClickEvent,
			minZoom: 6,
			maxZoom: 10,
		});
	
		// 검색 결과 리스트 추가
		if (searchableItems.includes(activeItem)) {
			$(".tabWrap .tab.active .searchWrap .listWrap").append(
			`<span class="lst_${id}_${ele.gid}" 
				data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
				data-id='${id}' 
				data-active-item='${activeItem}'>
				${ele.parkName || ele.busstopName || ele.areaName}
			</span>`
			);
		}
		});
	
		// 오버레이 클릭 이벤트 등록 (이벤트 위임 방식)
		$(".tabWrap .tab.active .searchWrap .listWrap").off("click").on("click", "span", (event) => {
		const target = $(event.currentTarget);
		const eleAttr = target.attr("data-ele");
		const overlayId = target.attr("data-id") + "_removeOverlay";
		const activeItem = target.attr("data-active-item");
	
		if (!eleAttr) {
			console.error("data-ele 값이 없습니다.");
			return;
		}
	
		try {
			const ele = JSON.parse(eleAttr);
			if (typeof this._overlayClickEvent === "function") {
			this._overlayClickEvent(ele, overlayId, activeItem, false, true);
			} else {
			console.error("_overlayClickEvent 함수가 존재하지 않습니다.");
			}
		} catch (error) {
			console.error("JSON 파싱 오류:", error);
		}
		});
	
		// 리스트 위치 조정
		const topPosition = {
		trafficAreas: "270px",
		platform: "230px",
		parking: "230px",
		};
		if (topPosition[activeItem]) {
		$(".tabWrap .tab.active .searchWrap .listWrap").css("top", topPosition[activeItem]);
		}
	};

	// 트리 범례 생성
	createTreeLegend = (props) => {
		if (this.state.activeItem === "traffic") {
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span style={{ display: "inline-block" }} className="tag traffic">
								원활
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "70px",
								}}
								className="text"
							>
								원활
							</span>

							<span style={{ display: "inline-block" }} className="tag traffic2">
								서행
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "62px",
								}}
								className="text"
							>
								서행
							</span>

							<span style={{ display: "inline-block" }} className="tag traffic3">
								지체
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "62px",
								}}
								className="text"
							>
								지체
							</span>

							<span style={{ display: "inline-block" }} className="tag traffic4">
								정보없음
							</span>
							<span style={{ display: "inline-block" }} className="text">
								정보없음
							</span>
						</div>
					</div>
				</>
			);
		} else {
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span style={{ display: "inline-block" }} className="tag parking">
								공영
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								공영
							</span>

							<span style={{ display: "inline-block" }} className="tag parking2">
								민영
							</span>
							<span style={{ display: "inline-block" }} className="text">
								민영
							</span>
						</div>
					</div>
				</>
			);
		}
	};

	// 검색
	search = async (evt, id) => {

		const { setLoading } = this.context; // ✅ context에서 setLoading 가져오기
    	setLoading(true); // 예제: 로딩 상태 변경
		$(".layerOpen").css("display","block");

		const { activeItem } = this.state;
		const { actions, sis, layout } = this.props;

		let stdYmd = document.querySelector("select#selectLivingStdYmd");
		// stdYmd 값을 select에서 직접 가져오기
		if (stdYmd) {
			stdYmd = stdYmd.value ;
		} else {
			stdYmd = null;  // 요소가 없으면 기본값 null 설정
		}

		// 기준년도 값이 없으면 1초 대기 후 실행
		const waitForStdYmd = () => {
			return new Promise(resolve => {
			  if (!stdYmd || stdYmd.trim() === "") {
				//console.log("기준년도 값이 없습니다. 1초 대기 중...");
				// 1초 대기 후, resolve를 호출하여 대기 끝냄
				setTimeout(() => {
				  resolve(); // Promise를 해결하여 대기 종료
				}, 1000);
			  } else {
				//console.log("기준년도 값이 있습니다.");
				resolve(); // 바로 resolve하여 대기 없이 진행
			  }
			});
		  };
		
		  // 비동기적으로 처리할 함수
		  await waitForStdYmd(); // 기준년도 값이 없으면 1초 기다리기

		let title = "";
		let data = [];
		//let stdYmd = "";
		let guBun = "0";

		if (["trafficAreas", "platform", "parking"].includes(activeItem)) {
			stdYmd = $("select#selectTransportationStdYmd").val() || $("select#selectTransportationStdYmd option:first").val() || "0";
			guBun = $("select#selectTransportationGb").val() || $("select#selectTransportationGb option:first").val() || "0";
		}
		
		let params = {
			sggCode: $("select#selectTransportationSgg").val(),
			emdCode: $("select#selectTransportationEmd").val(),
			stdYmd: stdYmd,
			guBun: guBun,
		};

	
		let color = "#ff0000";
		let url = "";
		let type = "point";
		let legend = "";

		let cctvData = [];


		if (activeItem === "traffic") {
			title = "교통정보";
			type = "traffic";
			// url = "/map/selectCCTV";
			url = "/uticMap/mapcctv.do";
			legend = this.createTreeLegend({
				data,
				id: `transportation_${id}`,
			});

			// 행정구역 불러오기
			$.ajax({
				url: "/map/selectTrafficInfo",
				type: "post",
				data: params,
				success: (res) => {
					data = res.items ? res.items : res;

					if (data.length === 0) {
						alert("검색결과가 없습니다.");
						setLoading(false);
						return;
					}

					if (res.wkt) {
						const feature = sis.sisLayer.createFeatureByWKT(res.wkt);
						feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
						const extent = feature.getGeometry().getExtent();

						sis.sisMap.view.fit(extent);
					}
				},
			});

			// 국도토교통부 cctv 불러오기
			// $.ajax({
			// 	url: "/map/selectCCTV",
			// 	type: "post",
			// 	data: params,
			// 	success: (res) => {
			// 		data = res.items ? res.items : res;
			// 		cctvData = data;
			// 	},
			// });

			// return;
		} else if (activeItem === "parking") {
			title = "주차장 정보";
			color = "#00bcd4";
			url = "/map/selectCarParkInfo";
			legend = this.createTreeLegend({
				data,
				id: `transportation_${id}`,
			});
		} else if (activeItem === "platform") {
			title = "승강장별 승차인원현황";
			color = "#4caf50";
			url = "/map/selectarPlatform";
			//legend = this.createTreeLegend({
			//	data,
			//	id: `transportation_${id}`,
			//});
		}else if (activeItem === "trafficAreas") {
			title = "도심지점별교통량";
			color = "#4caf50";
			url = "/map/selectarTrafficAreas";
			//legend = this.createTreeLegend({
			//	data,
			//	id: `transportation_${id}`,
			//});
		} else {return;}
		// } else {
		// 	title = "무더위쉼터";
		// 	color = "#4caf50";
		// 	url = "/map/selectSwelterShelter";
		// }

		$.ajax({
			url,
			type: "get",
			data: params,
			// async: false,
			success: (res) => {
				data = res.items ? res.items : res;

				if (activeItem === "traffic") {
					data = JSON.parse(data);
					// data = data.concat(cctvData);
				}

				if (data.length === 0) {
					alert("검색결과가 없습니다.");
					return;
				}

				if (res.wkt) {
					const feature = sis.sisLayer.createFeatureByWKT(res.wkt);
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					const extent = feature.getGeometry().getExtent();

					sis.sisMap.view.fit(extent);
				}

				const lyr = sis.sisLayer.getLayerById(`transportation_${activeItem}`);

				if (lyr) {
					actions.deleteResult({
						id: `transportation_${activeItem}`,
						refresh: true,
					});
				}

				// 트리아이템 생성
				actions.addResultItem({
					data: legend,
					id: `transportation_${activeItem}`,
					title,
					closeEvent: actions.deleteResult,
					checkboxEvent: actions.resultCheckboxHandler,
				});

				// 레이어 생성
				actions.addResultLayer({
					data,
					id: `transportation_${activeItem}`,
					type,
					color,
					callback: () => {
						requestAnimationFrame(() => {
							setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
						  });
					  }
				});
				
				// 오버레이 생성
				if(activeItem==="trafficAreas"){
					this.createOverlay(data, `transportation_${activeItem}`);
				}else if (type !== "wkt" && type != "traffic") { this.createOverlay(data, `transportation_${activeItem}`); }
				else{

				}
			},
		});
	};

	// 날짜 일 생성
	genDayList = () => {
		const year = $("select#selectYear").val();
		const month = $("select#selectMonth").val();
		const srchDate = new Date(year, month, 0);
		let dayList = [];
		for (var i = 1; i <= srchDate.getDate(); i++) {
			dayList.push({
				code: i,
				name: i + "일",
			});
		}
		this.setState({
			lstDay: dayList,
		});
	};

	

	render() {
		const { activeItem } = this.state;
		const { lstSgg, defaultSggCd } = this.props.sis;
		let searchElement;
		let yearList = [];
		let monthList = [];

		const nowDate = new Date();
		// 연도 생성
		for (let i = 2020; i <= nowDate.getFullYear(); i++) {
			yearList.push({
				code: i,
				name: i + "년",
			});
		}
		// 월 생성
		for (let i = 1; i <= 12; i++) {
			monthList.push({
				code: i,
				name: i + "월",
			});
		}

		if(activeItem === "parking"){
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectTransportationStdYmd"
							ref={(ref) => (this.selectTransportationStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}

							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectTransportationSgg"
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectTransportationEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		} else if(activeItem === "trafficAreas"){
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectTransportationStdYmd"
							ref={(ref) => (this.selectTransportationStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}

							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectTransportationSgg"
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectTransportationEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>

					<div className="inputWrap">
						<span className="selectTitle">측정시간</span>
						<SisSelect
							id="selectTransportationGb"							
							className="select"
							mapping={{
								key: "group",
								text: "name",
							}}
							items={this.state.lstGb}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}else if(activeItem === "platform"){
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectTransportationStdYmd"
							ref={(ref) => (this.selectTransportationStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}

							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectTransportationSgg"
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectTransportationEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		} else {
			if (this.state.lstEmd.length === 0) {
				this.getEmd(defaultSggCd);
			}

			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectTransportationSgg"
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							//onChange={this.getEmd}
							//onLoaded={this.getEmd}
						/>
					</div>
					{/*<div className="inputWrap">
						<span className="selectTitle">읍면동</span>
						<SisSelect
							id="selectTransportationEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>*/}

					<div className="btnWrap">
						<button id="btnRefresh">초기화</button>
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}

		return (
			<div id="transportationWrap" className="contentsWrap">
				<div className="title">
					<span>{this.state.title}</span>
					<div className="close" onClick={this.closeSearchWrap}>
						<MdClose />
					</div>
				</div>
				<div className="source" style={{display:"none"}}>
					<span className="origin_tit">출처</span>
					<span className="origin_stxt">{this.state.source}</span>
				</div>
				<div className="itemsWrap">
					<div id="platform" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="승강장별 승차인원현황" src="/sis/images/map/transportation/icBus.png" />*/}
						<span>승강장별 승차인원현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					{/* <div id="traffic" className="item" onClick={this.openSearchWrap}>
						<img className="logo" alt="교통정보" src="/sis/images/map/transportation/icTraffic.png" />
						<span>교통정보</span>
						<IoIosArrowForward className="arrow" />
					</div>*/}

					

					<div id="parking" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="주차장 현황" src="/sis/images/map/transportation/icParking.png" />*/}
						<span>주차장 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					
					<div id="trafficAreas" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="고속버스" src="/sis/images/map/transportation/icBus.png" />*/}
						<span>도심지점별 교통량</span>
						<IoIosArrowForward className="arrow" />
					</div>
				</div>

				<div className="searchWrap">{searchElement}</div>
			</div>
		);
	}
}

function appendZeroValue(target) {
	if (target.toString().length === 1) {
		return "0" + target;
	} else {
		return target;
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		actions: bindActionCreators(sisMapActions, dispatch),
	})
)(Transportation);

function getWmsBounds(x, y, z) {
	var res = [32, 64, 128, 256, 512, 1024, 2048, 4096, 8192, 16384, 32768, 65536, 131072];
	var minX = -30000 + res[z] * x;
	var minY = -60000 + res[z] * y;
	return minX + "," + minY + "," + (minX + res[z]) + "," + (minY + res[z]);
}
